export default __webpack_public_path__ + "assets/media/Top_Banner_TABLET.2b228b38.webp";